import React, {useEffect, useState} from "react";
import Alert from "react-bootstrap/Alert";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import BankConnectModal from "./BankConnectModal";
import {FaFileContract} from "react-icons/fa6";
import Button from "react-bootstrap/Button";
import {setEditBankAccount} from "../../../../_reducers/DataPanel/Cash/cashSlice";

const BankAccountStatus = ({bankId}) => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [status, setStatus] = useState(""); // empty, "hooked", "hookable", "error"
    const [data, setData] = useState({}); // Agreement object

    const [showConnectBank, setShowConnectBank] = useState(false);

    useEffect(() => {
        if (bankId) fetchOpseosAgreementStatus();
    }, [bankId])

    const fetchOpseosAgreementStatus = () => {
        setData({});
        setStatus("");
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/bank-account-status`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
                bankId: bankId,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                setData(res.data.data);
                setStatus("hooked");
            } else {
                setStatus("hookable");
            }
        }).catch((err) => {
            console.log(err);
            setStatus("error");
        })
    }

    const onSuccess = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/cash/bank-account`, {
            headers: { "Content-Type": "application/json" },
            params: {
                company: company.id,
                bankId: bankId,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setEditBankAccount(res.data.data));
                fetchOpseosAgreementStatus();
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    return (
        <React.Fragment>
            {(Object.keys(data).length > 0 && status === "hooked") && (
                <Alert variant={"secondary"}>
                    Ο λογαριασμός έχει διασυνδεθεί επιτυχώς με το τραπεζικό ίδρυμα.<br/>
                    <strong>Κωδικός διασύνδεσης:</strong> {data.agreementId}<br/>
                    <strong>Τραπεζικό ίδρυμα:</strong> {data.agreementInstitutionId}<br/>
                    <strong>Έναρξη διασύνδεσης:</strong> {moment(data.agreementDate).format("DD/MM/YYYY HH:mm:ss")}<br/>
                    <strong>Λήξη διασύνδεσης:</strong> {moment(data.agreementEndDate).format("DD/MM/YYYY HH:mm:ss")}<br/>
                </Alert>
            )}
            {status === "hookable" && (
                <React.Fragment>
                    <Alert variant={"secondary"}>
                        Ο λογαριασμός δεν είναι διασυνδεδεμένος με το τραπεζικό ίδρυμα. Μπορείτε να τον διασυνδέσετε πατώντας το παρακάτω κουμπί.<br/>
                        <u><strong>Προσοχή:</strong></u> Υπάρχει η δυνατότητα με μία διασύνδεση να διασυνδεθούν πολλαπλοί τραπεζικοί λογαριασμοί.
                        Βεβαιωθείτε επίσης ότι το IBAN που έχετε συμπληρώσει είναι σωστό και ανήκει στο τραπεζικό ίδρυμα που επρόκειτο να διασυνδεθείτε.
                        <div style={{textAlign: "center"}}>
                            <Button onClick={() => setShowConnectBank(true)} style={{marginTop: "23px"}} className={"ml-2"}><FaFileContract /> Νέα διασύνδεση</Button>
                        </div>
                    </Alert>

                    <BankConnectModal
                        show={showConnectBank}
                        setShow={setShowConnectBank}
                        successfulCallback={() => onSuccess()}
                    />
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default BankAccountStatus;
